export const MATCH_STATUS_NOT_STARTED = 0;
